export default "__VITE_ASSET__b48092dc__"